export default "__VITE_ASSET__36950eae__"